import Vue from 'vue';
export const LessIcon = Vue.extend({
    functional: true,
    name: 'LessIcon',
    render(createElement, ctx) {
        return (<svg viewBox="0 0 50 50">
                <g transform="matrix(2.0833333,0,0,2.0833333,-27.083333,-27.083333)">
                    <polygon style="fill:#ffffff" points="25.78,24.34 24.22,24.34 19.85,24.34 19.85,25.82 24.22,25.82 25.78,25.82 30.15,25.82 30.15,24.34 "/>
                </g>
            </svg>);
    },
});
//# sourceMappingURL=LessIcon.jsx.map